import $ from "jquery";

/**
 * request live validation after keyup event on some password inputs)
 */
export default (props, e) => {
	$(e.target).trigger('requestValidation');
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/passwordStrength.js